// extracted by mini-css-extract-plugin
export default {"versionIndicator":"u4nkTLs_OdxEEdlVce9M","long":"HtL1D6XghaKzTaeb7rhl","activated":"gX7O62PPwWtxxLrMUsHI","veryLong":"NlVElLhRrupO69r7b4nt","versionIndex":"pgo0KEooXwLEAISHpbmV"};